import {
  SiTypescript,
  SiReact,
  SiNodedotjs,
  SiDocker,
  SiKubernetes,
  SiFirebase,
  SiMongodb,
  SiPostgresql,
  SiGit,
  SiJira,
  SiFigma,
  SiGraphql,
  SiRedis,
  SiNginx,
  SiJest,
  SiCypress,
} from "react-icons/si";
import { FaCloud } from "react-icons/fa";

export const LANGUAGES_FRAMEWORKS = [
  { name: "TypeScript / JavaScript", level: 95, color: "#3178c6", icon: SiTypescript, delay: 0 },
  { name: "React / React Native", level: 95, color: "#61dafb", icon: SiReact, delay: 0.1 },
  { name: "Vue.js / Nuxt.js", level: 90, color: "#42b883", icon: SiReact, delay: 0.2 },
  { name: "Node.js / Express", level: 90, color: "#339933", icon: SiNodedotjs, delay: 0.3 },
  { name: "Next.js", level: 90, color: "#000000", icon: SiReact, delay: 0.4 },
  { name: "NestJS", level: 88, color: "#e0234e", icon: SiNodedotjs, delay: 0.5 },
  { name: "Angular", level: 80, color: "#dd0031", icon: SiReact, delay: 0.6 },
  { name: "Redux / State Management", level: 92, color: "#764abc", icon: SiReact, delay: 0.7 },
];

export const CLOUD_DEVOPS = [
  { name: "Azure (VMs, Functions, Blob, SQL)", level: 90, color: "#0078d4", icon: FaCloud, delay: 0 },
  { name: "Docker & Containerization", level: 90, color: "#2496ed", icon: SiDocker, delay: 0.1 },
  { name: "Kubernetes", level: 82, color: "#326ce5", icon: SiKubernetes, delay: 0.2 },
  { name: "CI/CD (GitHub Actions, Jenkins)", level: 88, color: "#24292e", icon: SiGit, delay: 0.3 },
  { name: "Nginx / Load Balancing", level: 80, color: "#009639", icon: SiNginx, delay: 0.4 },
];

export const DATABASES = [
  { name: "PostgreSQL / MySQL", level: 55, color: "#336791", icon: SiPostgresql, delay: 0 },
  { name: "MongoDB / NoSQL", level: 88, color: "#47a248", icon: SiMongodb, delay: 0.1 },
  { name: "Redis / Caching", level: 85, color: "#dc382d", icon: SiRedis, delay: 0.2 },
  { name: "Firebase / Firestore", level: 90, color: "#ffca28", icon: SiFirebase, delay: 0.3 },
];

export const TECH_ICONS = [
  { icon: SiTypescript, label: "TypeScript", delay: 0 },
  { icon: SiReact, label: "React", delay: 0.05 },
  { icon: SiNodedotjs, label: "Node.js", delay: 0.1 },
  { icon: SiReact, label: "Next.js", delay: 0.15 },
  { icon: FaCloud, label: "Azure", delay: 0.2 },
  { icon: SiDocker, label: "Docker", delay: 0.25 },
  { icon: SiKubernetes, label: "Kubernetes", delay: 0.3 },
  { icon: SiFirebase, label: "Firebase", delay: 0.35 },
  { icon: SiMongodb, label: "MongoDB", delay: 0.45 },
  { icon: SiPostgresql, label: "PostgreSQL", delay: 0.5 },
  { icon: SiNodedotjs, label: "NestJS", delay: 0.55 },
  { icon: SiGraphql, label: "GraphQL", delay: 0.6 },
  { icon: SiRedis, label: "Redis", delay: 0.65 },
  { icon: SiJest, label: "Jest", delay: 0.7 },
  { icon: SiCypress, label: "Cypress", delay: 0.75 },
  { icon: SiGit, label: "Git", delay: 0.8 },
  { icon: SiFigma, label: "Figma", delay: 0.85 },
  { icon: SiJira, label: "Jira", delay: 0.9 },
];
